import { PayloadAction, createSlice } from '@reduxjs/toolkit';

type FilterValue = string | number | boolean | null | undefined;

type PageFilters = Record<string, FilterValue>;

type PageFiltersState = {
  [pageKey: string]: PageFilters;
};

const initialState: PageFiltersState = {};

export const pageFiltersSlice = createSlice({
  name: 'pageFilters',
  initialState,
  reducers: {
    setPageFilters: (state, action: PayloadAction<{ pageKey: string; filters: PageFilters }>) => {
      const { pageKey, filters } = action.payload;
      state[pageKey] = filters;
    },

    updatePageFilters: (
      state,
      action: PayloadAction<{ pageKey: string; filters: Partial<PageFilters> }>,
    ) => {
      const { pageKey, filters } = action.payload;
      if (state[pageKey]) {
        state[pageKey] = { ...state[pageKey], ...filters };
      } else {
        state[pageKey] = filters;
      }
    },

    clearPageFilters: (state, action: PayloadAction<string>) => {
      const pageKey = action.payload;
      delete state[pageKey];
    },

    clearAllFilters: () => initialState,
  },
});

export const { setPageFilters, updatePageFilters, clearPageFilters, clearAllFilters } =
  pageFiltersSlice.actions;

export default pageFiltersSlice.reducer;
